import React from 'react';
import { useTabContext } from '@/components/context/TabContext';

const NextButton = ({ swiperRef }) => {
  const { selectedTab } = useTabContext();

  return (
    <button
      onClick={() => swiperRef.current?.slideNext()}
      className="slider-button"
    >
      <img loading="lazy" src={`${selectedTab === 'adviser'
        ? '/img/icons/arrow-right.svg'
        : '/img/icons/arrow-narrow-right.svg'} `}
      className="w-4 h-4"
      alt="next"
      />
    </button>
  );
};

export default NextButton;
